import PhotoHeading from '../src/PhotoHeading';
export default PhotoHeading;
